<template>
  <div class="lesson-container">
    <div class="container">
      <div class="header">
        <div class="floating-orb"></div>
        <h1>{{ planTitle }}</h1>
        <p v-if="planIndicator">
          <strong>Indicadores:</strong> {{ planIndicator }}
        </p>
      </div>
      <table class="planning-table">
        <!-- INICIO -->
        <tr>
          <td class="section-header inicio-header">INICIO</td>
        </tr>
        <tr>
          <td class="content-cell inicio">
            <div class="subsection-title">Pregunta</div>
            <p v-html="inicioPregunta"></p>
          </td>
        </tr>
        <tr>
          <td class="content-cell inicio">
            <div class="subsection-title">Bajada de pregunta</div>
            <p v-html="inicioBajada"></p>
          </td>
        </tr>
        <tr>
          <td class="content-cell inicio">
            <div class="subsection-title">Introducción del objetivo</div>
            <p v-html="inicioIntro"></p>
          </td>
        </tr>

        <!-- DESARROLLO -->
        <tr>
          <td class="section-header desarrollo-header">DESARROLLO</td>
        </tr>
        <tr>
          <td class="content-cell desarrollo">
            <div class="subsection-title">Explicación</div>
            <p v-html="desarrolloExplicacion"></p>
          </td>
        </tr>
        <tr>
          <td class="content-cell desarrollo">
            <div class="subsection-title">
              Entrégale un paso a paso como forma de automonitoreo a los
              estudiantes
            </div>
            <ul v-if="desarrolloPasoAPaso.length > 0">
              <li
                v-for="(paso, index) in desarrolloPasoAPaso"
                :key="index"
                v-html="paso"
              ></li>
            </ul>
            <p v-else>No hay pasos definidos.</p>
          </td>
        </tr>
        <tr>
          <td class="content-cell desarrollo">
            <div class="subsection-title">
              Avísale a los estudiantes cuáles son los errores comunes para que
              se anticipen
            </div>
            <p v-html="desarrolloErrores"></p>
          </td>
        </tr>
        <tr>
          <td class="content-cell desarrollo">
            <div class="subsection-title">
              Define y entrega los conceptos importantes antes de empezar la
              clase
            </div>
            <p v-html="desarrolloConceptos"></p>
          </td>
        </tr>
        <tr>
          <td class="content-cell desarrollo">
            <div class="subsection-title">
              Aterriza el contenido a un ejemplo cercano
            </div>
            <p v-html="desarrolloEjemplo"></p>
          </td>
        </tr>

        <!-- EJERCICIOS BLOOM -->
        <tr v-for="(ejercicio, index) in ejerciciosBloom" :key="index">
          <td class="content-cell desarrollo">
            <div class="subsection-title">{{ ejercicio.titulo }}</div>
            <div class="exercise-card">
              <div class="exercise-level">{{ ejercicio.nivel }}</div>
              <div class="exercise-content">
                <p v-html="ejercicio.pregunta"></p>
                <div
                  v-if="ejercicio.opciones"
                  class="exercise-options"
                  v-html="ejercicio.opciones"
                ></div>
                <div
                  v-if="ejercicio.respuesta"
                  class="exercise-answer"
                  v-html="ejercicio.respuesta"
                ></div>
              </div>
            </div>
          </td>
        </tr>

        <!-- CIERRE -->
        <tr>
          <td class="section-header cierre-header">CIERRE</td>
        </tr>
        <tr>
          <td class="content-cell cierre">
            <div class="subsection-title">Reflexión final</div>
            <p v-html="cierreReflexion"></p>
          </td>
        </tr>
        <tr>
          <td class="content-cell cierre">
            <div class="subsection-title">Despedida</div>
            <p v-html="cierreDespedida"></p>
          </td>
        </tr>
      </table>
    </div>
    <!-- {{ text }} -->
  </div>
</template>

<script>
import chatBotService from "@/services/chatBotService";

export default {
  name: "DailyPlanification",
  props: {
    subject: { type: String, required: false },
    grade: { type: String, required: false },
    oa: { type: Object, required: false },
    ind: { type: Array, required: false },
    type: { type: String, required: false },
    demo: { type: Boolean, required: false },
    condition: { type: String, required: true },
  },
  data() {
    return {
      text: "",
      previous: false,
      // Estructura para el display moderno
      inicioPregunta: "",
      inicioBajada: "",
      inicioIntro: "",
      desarrolloConceptos: "",
      desarrolloExplicacion: "",
      desarrolloEjemplo: "",
      desarrolloPasoAPaso: [],
      desarrolloErrores: "",
      ejerciciosBloom: [],
      cierreReflexion: "",
      cierreDespedida: "",
    };
  },
  computed: {
    planTitle() {
      let title = "";

      if (this.oa && this.oa.name) {
        title = this.oa.name;
      } else if (this.oa && typeof this.oa === "string") {
        title = this.oa;
      } else if (this.oa && this.oa.title) {
        title = this.oa.title;
      } else {
        title = "Planificación diaria";
      }

      // Limpiar HTML del título
      title = title.replace(/<[^>]*>/g, "");

      return title;
    },
    planIndicator() {
      if (this.ind && this.ind.length > 0) {
        const indicators = this.ind
          .map((i) => {
            // Limpiar HTML de cada indicador
            let name = i.name || "";
            name = name.replace(/<[^>]*>/g, "");
            return name;
          })
          .join(", ");
        return indicators;
      }
      return "";
    },
  },
  mounted() {
    if (!this.demo) {
      // this.getDailyPlanification();
      this.getDailyPlanificationStructured();
    }
  },
  methods: {
    getDailyPlanificationStructured() {
      var clearOA = this.oa;
      clearOA.subtags = [];
      chatBotService
        .getDailyPlanificationStructured(
          this.subject,
          this.grade,
          clearOA,
          this.type,
          this.ind.map((i) => {
            return { name: i.name, description: i.description };
          }),
          this.condition
        )
        .then((body) => {
          const reader = body.getReader();
          const decoder = new TextDecoder();
          var vue_context = this;
          function processChunk({ done, value }) {
            if (value) {
              const decodedChunk = decoder.decode(value);
              vue_context.text += decodedChunk;
              // vue_context.parseText(); // ACTUALIZA EL DISPLAY EN CADA CHUNK
            }
            if (done) {
              // vue_context.parseText();
              // Crear objeto con los datos de la planificación actual
              // const planificationData = {
              //  type: vue_context.type,
              //  inicio: {
              //    pregunta: vue_context.inicioPregunta,
              //    bajada: vue_context.inicioBajada,
              //    intro: vue_context.inicioIntro,
              //  },
              //  desarrollo: {
              //    explicacion: vue_context.desarrolloExplicacion,
              //    pasoAPaso: vue_context.desarrolloPasoAPaso,
              //    errores: vue_context.desarrolloErrores,
              //    conceptos: vue_context.desarrolloConceptos,
              //    ejemplo: vue_context.desarrolloEjemplo,
              //    ejerciciosBloom: vue_context.ejerciciosBloom,
              //  },
              //  cierre: {
              //    reflexion: vue_context.cierreReflexion,
              //    despedida: vue_context.cierreDespedida,
              //  },
              //  text: vue_context.text,
              //};
              //vue_context.$emit("done", planificationData);
              return;
            }
            return reader.read().then(processChunk);
          }
          reader.read().then(processChunk);
        });
    },
    getDailyPlanification() {
      var clearOA = this.oa;
      clearOA.subtags = [];
      chatBotService
        .getDailyPlanification(
          this.subject,
          this.grade,
          clearOA,
          this.type,
          this.ind.map((i) => {
            return { name: i.name, description: i.description };
          }),
          this.condition
        )
        .then((body) => {
          const reader = body.getReader();
          const decoder = new TextDecoder();
          var vue_context = this;
          function processChunk({ done, value }) {
            if (value) {
              const decodedChunk = decoder.decode(value);
              vue_context.text += decodedChunk;
              vue_context.parseText(); // ACTUALIZA EL DISPLAY EN CADA CHUNK
            }
            if (done) {
              vue_context.parseText();
              // Crear objeto con los datos de la planificación actual
              const planificationData = {
                type: vue_context.type,
                inicio: {
                  pregunta: vue_context.inicioPregunta,
                  bajada: vue_context.inicioBajada,
                  intro: vue_context.inicioIntro,
                },
                desarrollo: {
                  explicacion: vue_context.desarrolloExplicacion,
                  pasoAPaso: vue_context.desarrolloPasoAPaso,
                  errores: vue_context.desarrolloErrores,
                  conceptos: vue_context.desarrolloConceptos,
                  ejemplo: vue_context.desarrolloEjemplo,
                  ejerciciosBloom: vue_context.ejerciciosBloom,
                },
                cierre: {
                  reflexion: vue_context.cierreReflexion,
                  despedida: vue_context.cierreDespedida,
                },
                text: vue_context.text,
              };
              vue_context.$emit("done", planificationData);
              return;
            }
            return reader.read().then(processChunk);
          }
          reader.read().then(processChunk);
        });
    },
    // Parser robusto para negrita, listas y saltos de línea
    formatRichText(text) {
      if (!text) return "";

      let formatted = text.trim();

      // 1. Normalizar saltos de línea (soportar \r\n y \n)
      formatted = formatted.replace(/\r\n/g, "\n").replace(/\r/g, "\n");

      // 2. Convertir \n\n en párrafos separados y \n en <br>
      let html = "";

      // Dividir por dobles saltos de línea para crear párrafos
      let paragraphs = formatted
        .split(/\n\s*\n/)
        .map((p) => p.trim())
        .filter(Boolean);

      html = paragraphs
        .map((paragraph) => {
          // Procesar negritas primero
          let content = paragraph.replace(
            /\*\*(.*?)\*\*/g,
            "<strong>$1</strong>"
          );

          // Procesar saltos de línea simples como <br>
          content = content.replace(/\n/g, "<br>");

          return `<p>${content}</p>`;
        })
        .join("");

      return html;
    },
    formatBuffer(buffer) {
      const pendingElements = [];
      let newBuffer = buffer;
      for (let i = 0; i < buffer.length; i++) {
        if (buffer[i] === "{") {
          pendingElements.push("{");
        }
        if (buffer[i] === "[") {
          pendingElements.push("[");
        }
        if (buffer[i] === '"') {
          if (
            pendingElements.length > 0 &&
            pendingElements[pendingElements.length - 1] === '"'
          ) {
            pendingElements.pop();
          } else {
            pendingElements.push('"');
          }
        }
        if (buffer[i] === "}") {
          if (
            pendingElements.length > 0 &&
            pendingElements[pendingElements.length - 1] === "{"
          ) {
            pendingElements.pop();
          }
        }
        if (buffer[i] === "]") {
          if (
            pendingElements.length > 0 &&
            pendingElements[pendingElements.length - 1] === "["
          ) {
            pendingElements.pop();
          }
        }
      }
      while (pendingElements.length > 0) {
        const lastElement = pendingElements.pop();
        if (lastElement === "{") {
          newBuffer += "}";
        } else if (lastElement === '"') {
          newBuffer += '"';
        } else if (lastElement === "[") {
          newBuffer += "]";
        }
      }
      return newBuffer;
    },
    parseText() {
      // Extraer secciones principales
      var inicio = "";
      var desarrollo = "";
      var cierre = "";
      var inicioMatch = this.text.match(
        /\[inicio_clase\](.*?)(?=\[desarrollo_clase\]|$)/s
      );
      var desarrolloMatch = this.text.match(
        /\[desarrollo_clase\](.*?)(?=\[cierre_clase\]|$)/s
      );
      var cierreMatch = this.text.match(/\[cierre_clase\](.*?)$/s);
      if (inicioMatch) inicio = inicioMatch[1].trim();
      if (desarrolloMatch) desarrollo = desarrolloMatch[1].trim();
      if (cierreMatch) cierre = cierreMatch[1].trim();

      // INICIO
      if (inicio) {
        try {
          // let formattedInicio = JSON.parse(this.formatBuffer(inicio));
          this.inicioPregunta = this.formatRichText(
            // formattedInicio.question
            this.extractTag(inicio, "question")
          );

          this.inicioBajada = this.formatRichText(
            // formattedInicio.question_relation
            this.extractTag(inicio, "question_relation")
          );

          this.inicioIntro = this.formatRichText(
            // formattedInicio.introduction
            this.extractTag(inicio, "introduction")
          );
        } catch (e) {
          null;
        }
      }

      // DESARROLLO - en orden de llegada
      if (desarrollo) {
        try {
          // let formattedDesarrollo = JSON.parse(this.formatBuffer(desarrollo));
          this.desarrolloExplicacion = this.formatRichText(
            // formattedDesarrollo.explanation
            this.extractTag(desarrollo, "explanation")
          );
        } catch (e) {
          null;
        }
      }
      this.desarrolloPasoAPaso = this.extractList(desarrollo, "Pasos").map(
        this.formatRichText
      );

      this.desarrolloErrores = this.formatRichText(
        this.extractTag(desarrollo, "Errores")
      );
      this.desarrolloConceptos = this.formatRichText(
        this.extractTag(desarrollo, "Conceptos")
      );
      this.desarrolloEjemplo = this.formatRichText(
        this.extractTag(desarrollo, "Ejemplo")
      );

      // BLOOM: ejercicios
      this.ejerciciosBloom = this.extractBloom(desarrollo);

      // CIERRE
      if (cierre) {
        try {
          // let formattedCierre = JSON.parse(this.formatBuffer(cierre));
          this.cierreReflexion = this.formatRichText(
            // formattedCierre.final_thoughts
            this.extractTag(cierre, "final_thoughts")
          );
          this.cierreDespedida = this.formatRichText(
            // formattedCierre.motivation
            this.extractTag(cierre, "motivation")
          );
        } catch (e) {
          null;
        }
      }
    },
    extractTag(section, tag) {
      if (!section) return "";
      const regex = new RegExp(`\\[${tag}\\](.*?)(?=\\[|$)`, "s");
      const match = section.match(regex);
      if (match && match[1]) {
        // Preservar saltos de línea y espacios originales, pero limpiar caracteres extraños
        let content = match[1].trim();

        // Limpiar caracteres de control pero preservar saltos de línea
        content = content.replace(/\r\n/g, "\n");
        content = content.replace(/\r/g, "\n");
        content = content.replace(/\t/g, " ");

        // NO eliminar espacios múltiples aquí, solo al inicio y final de líneas
        content = content
          .split("\n")
          .map((line) => line.trim())
          .join("\n");

        return content;
      }
      return "";
    },
    extractList(section, tag) {
      const content = this.extractTag(section, tag);
      if (!content) return [];

      // Si el contenido ya tiene formato de lista numerada, devolverlo como un solo elemento
      // para que formatRichText lo procese correctamente
      if (content.match(/^\d+\./m)) {
        return [content];
      }

      // Solo dividir si no es una lista numerada
      return content
        .split(/<br>|\n|\r|\u2022|-/)
        .map((item) => item.trim())
        .filter((item) => item.length > 0 && item !== "<br>");
    },
    extractBloom(section) {
      const niveles = [
        { tag: "Recordar", titulo: "Nivel 1 Recordar datos o conceptos" },
        {
          tag: "Entender",
          titulo: "Nivel 2 Explicar con sus propias palabras",
        },
        { tag: "Aplicar", titulo: "Nivel 3 Aplicar en situaciones nuevas" },
        { tag: "Analizar", titulo: "Nivel 4 Analizar la información" },
        { tag: "Evaluar", titulo: "Nivel 5 Evaluar contextos" },
      ];
      let ejercicios = [];
      niveles.forEach((nivel) => {
        const regex = new RegExp(`\\[${nivel.tag}\\](.*?)(?=\\[|$)`, "s");
        const match = section.match(regex);
        if (match && match[1]) {
          const contenido = match[1].trim();

          let pregunta = contenido;
          let opciones = "";
          let respuesta = "";

          // Si hay opciones tipo A) B) C) D)
          if (pregunta.match(/A\)/)) {
            const partes = pregunta.split(/(A\).*)/);
            pregunta = partes[0].trim();
            opciones = partes[1] ? partes[1].trim() : "";
          }

          // Mejorar el manejo de respuestas - buscar diferentes patrones
          const respuestaPatterns = [
            /\*\*Respuesta:\*\*(.*?)(?=\n|$)/i, // **Respuesta:** contenido
            /\*\*Respuesta:(.*?)\*\*/i, // **Respuesta:contenido**
            /Respuesta:\*\*(.*?)\*\*/i, // Respuesta:**contenido**
            /Respuesta:(.*?)(?=\n|$)/i, // Respuesta: contenido
          ];

          for (let pattern of respuestaPatterns) {
            if (pregunta.match(pattern)) {
              const match = pregunta.match(pattern);
              pregunta = pregunta.replace(pattern, "").trim();
              respuesta = match[0]; // Mantener el formato original
              break;
            }
          }

          ejercicios.push({
            nivel: nivel.tag,
            titulo: nivel.titulo,
            pregunta: this.formatRichText(pregunta),
            opciones: this.formatRichText(opciones),
            respuesta: this.formatRichText(respuesta),
          });
        }
      });
      return ejercicios;
    },
    /**
     * Construye el objeto 'sections' esperado por el backend para descargas,
     * usando el mismo parseo que la visualización. Así el backend sigue funcionando
     * sin cambios y el equipo puede mantener compatibilidad.
     * Siempre retorna un objeto válido, aunque falten tags o secciones.
     */
    buildSectionsObject() {
      // Extraer secciones principales del texto crudo
      const text = this.text || "";
      // Utiliza regex para extraer bloques
      const inicioMatch = text.match(
        /\[inicio_clase\](.*?)(?=\[desarrollo_clase\]|$)/s
      );
      const desarrolloMatch = text.match(
        /\[desarrollo_clase\](.*?)(?=\[cierre_clase\]|$)/s
      );
      const cierreMatch = text.match(/\[cierre_clase\](.*)/s);
      // Helper para extraer subsecciones por tag
      function extractSubsections(sectionText, tags) {
        if (!sectionText) return [];
        return tags
          .map((tag) => {
            const regex = new RegExp(`\\[${tag}\\](.*?)(?=\\[|$)`, "s");
            const match = sectionText.match(regex);
            return match
              ? {
                  name: tag.charAt(0).toUpperCase() + tag.slice(1),
                  content: match[1].trim(),
                }
              : null;
          })
          .filter(Boolean);
      }
      // Armar las secciones
      const sections = [];
      // INICIO
      if (inicioMatch) {
        sections.push({
          name: "INICIO",
          subsections: extractSubsections(inicioMatch[1], [
            "question",
            "question_relation",
            "introduction",
          ]),
        });
      }
      // DESARROLLO
      if (desarrolloMatch) {
        sections.push({
          name: "DESARROLLO",
          subsections: extractSubsections(desarrolloMatch[1], [
            "explanation",
            "stepbystep",
            "errors",
            "concepts",
            "example",
            "bloom",
          ]),
        });
      }
      // CIERRE
      if (cierreMatch) {
        sections.push({
          name: "CIERRE",
          subsections: extractSubsections(cierreMatch[1], [
            "reflection",
            "farewell",
          ]),
        });
      }
      // Siempre retorna un objeto con sections, oa e ind si existen
      return {
        sections,
        oa: this.oa || {},
        ind: this.ind || [],
      };
    },
    // Métodos de descarga ajustados para enviar el objeto correcto
    downloadWord() {
      const planification = this.buildSectionsObject();
      import("@/services/chatBotService").then((module) => {
        module.default
          .downloadPlanification({ planification })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Planificacion_Diaria.docx");
            document.body.appendChild(link);
            link.click();
            link.remove();
          });
      });
    },
    downloadPPT() {
      const planification = this.buildSectionsObject();
      import("@/services/chatBotService").then((module) => {
        module.default
          .downloadPptPlanification({ planification })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Planificacion_Diaria.pptx");
            document.body.appendChild(link);
            link.click();
            link.remove();
          });
      });
    },
  },
};
</script>

<style scoped>
.lesson-container {
  font-family: "Ubuntu", -apple-system, BlinkMacSystemFont, "Segoe UI",
    system-ui, sans-serif;
  background: #f7f7f7;
  min-height: 100vh;
  padding: 10px;
  position: relative;
}

.lesson-container .container {
  max-width: 1000px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.08), 0 5px 15px rgba(0, 0, 0, 0.04);
  position: relative;
  isolation: isolate;
}

.lesson-container .header {
  background: linear-gradient(135deg, #20b2aa 0%, #84cec7 100%);
  color: white;
  padding: 25px 30px;
  position: relative;
  z-index: 10;
  min-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(32, 178, 170, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  border-radius: 12px 12px 0 0;
  overflow: hidden;
}

.lesson-container .header::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 120px;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.15) 100%
  );
  z-index: 11;
  backdrop-filter: blur(10px);
}

.lesson-container .header::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle at 80% 20%,
    rgba(255, 255, 255, 0.2) 0%,
    transparent 50%
  );
  animation: headerShimmer 4s ease-in-out infinite;
  z-index: 1;
}

@keyframes headerShimmer {
  0%,
  100% {
    transform: rotate(0deg) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: rotate(180deg) scale(1.1);
    opacity: 0.1;
  }
}

.lesson-container .header h1 {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 10px;
  position: relative;
  z-index: 12;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3), 0 0 20px rgba(255, 255, 255, 0.1);
  line-height: 1.5;
  word-wrap: break-word;
  hyphens: auto;
  max-width: calc(100% - 80px);
}

.lesson-container .header p {
  font-size: 1rem;
  opacity: 0.95;
  position: relative;
  z-index: 12;
  font-weight: 400;
  line-height: 1.5;
  word-wrap: break-word;
  margin: 0;
  max-width: calc(100% - 80px);
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
}

.lesson-container .floating-orb {
  position: absolute;
  top: 15px;
  right: 25px;
  width: 60px;
  height: 60px;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0.3)
  );
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(15px);
  z-index: 15;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.4),
    0 0 40px rgba(32, 178, 170, 0.3), inset 0 0 20px rgba(255, 255, 255, 0.3);
  animation: orbMagic 6s ease-in-out infinite;
}

.lesson-container .floating-orb::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30px;
  height: 30px;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.8) 0%,
    transparent 70%
  );
  border-radius: 50%;
  animation: orbCore 3s ease-in-out infinite alternate;
}

.lesson-container .floating-orb::after {
  content: "";
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  animation: orbRing 4s linear infinite;
}

@keyframes orbMagic {
  0%,
  100% {
    transform: translateY(0px) scale(1) rotate(0deg);
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.4),
      0 0 40px rgba(32, 178, 170, 0.3), inset 0 0 20px rgba(255, 255, 255, 0.3);
  }
  33% {
    transform: translateY(-8px) scale(1.1) rotate(120deg);
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.6),
      0 0 60px rgba(32, 178, 170, 0.5), inset 0 0 25px rgba(255, 255, 255, 0.4);
  }
  66% {
    transform: translateY(-4px) scale(0.95) rotate(240deg);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.5),
      0 0 50px rgba(132, 206, 199, 0.4),
      inset 0 0 22px rgba(255, 255, 255, 0.35);
  }
}

@keyframes orbCore {
  0% {
    opacity: 0.6;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.2);
  }
}

@keyframes orbRing {
  0% {
    transform: rotate(0deg) scale(1);
    opacity: 0.3;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    transform: rotate(360deg) scale(1.1);
    opacity: 0.3;
  }
}

.lesson-container .planning-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: transparent;
  margin: 0;
  padding: 0;
  position: relative;
  z-index: 1;
}

.lesson-container .section-header {
  color: white;
  font-weight: 700;
  text-align: center;
  padding: 12px 15px;
  font-size: 0.9rem;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3), 0 0 15px rgba(255, 255, 255, 0.1);
  position: relative;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  border: none;
}

.lesson-container .planning-table tr:first-child td {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.lesson-container .planning-table tr:last-child td {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.lesson-container .inicio-header {
  background: linear-gradient(135deg, #20b2aa 0%, #84cec7 100%);
}

.lesson-container .desarrollo-header {
  background: linear-gradient(135deg, #c6588d 0%, #e8b5d1 100%);
}

.lesson-container .cierre-header {
  background: linear-gradient(135deg, #f8ac04 0%, #f9d38f 100%);
}

.lesson-container .section-header::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.7),
    transparent
  );
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
}

.lesson-container .content-cell {
  padding: 14px 20px;
  background: #ffffff;
  color: #2d3748;
  line-height: 1.4;
  font-size: 0.85rem;
  border-left: 4px solid transparent;
  border-bottom: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
}

.lesson-container .content-cell.inicio {
  border-left: 4px solid #20b2aa;
}

.lesson-container .content-cell.desarrollo {
  border-left: 4px solid #c6588d;
}

.lesson-container .content-cell.cierre {
  border-left: 4px solid #f8ac04;
}

.lesson-container .content-cell:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  z-index: 3;
  border-radius: 8px;
}

.lesson-container .subsection-title {
  font-weight: 600;
  font-size: 0.75rem;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 4px 10px;
  border-radius: 6px;
  display: inline-block;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.lesson-container .content-cell.inicio .subsection-title {
  background: linear-gradient(
    135deg,
    rgba(32, 178, 170, 0.15),
    rgba(132, 206, 199, 0.1)
  );
  color: #1a5f5a;
  border-left: 3px solid #20b2aa;
  box-shadow: 0 2px 8px rgba(32, 178, 170, 0.15);
}

.lesson-container .content-cell.desarrollo .subsection-title {
  background: linear-gradient(
    135deg,
    rgba(198, 88, 141, 0.15),
    rgba(232, 181, 209, 0.1)
  );
  color: #7a2d5c;
  border-left: 3px solid #c6588d;
  box-shadow: 0 2px 8px rgba(198, 88, 141, 0.15);
}

.lesson-container .content-cell.cierre .subsection-title {
  background: linear-gradient(
    135deg,
    rgba(248, 172, 4, 0.15),
    rgba(249, 211, 143, 0.1)
  );
  color: #b8640a;
  border-left: 3px solid #f8ac04;
  box-shadow: 0 2px 8px rgba(248, 172, 4, 0.15);
}

.lesson-container .content-cell p {
  margin-bottom: 6px;
  color: #374151;
  font-weight: 400;
  line-height: 1.5;
}

.lesson-container .content-cell p:last-child {
  margin-bottom: 0;
}

.lesson-container .exercise-card {
  background: linear-gradient(
    135deg,
    rgba(198, 88, 141, 0.08),
    rgba(232, 181, 209, 0.05)
  );
  border: 1px solid rgba(198, 88, 141, 0.2);
  border-radius: 10px;
  padding: 12px 16px;
  margin: 8px 0;
  border-left: 4px solid #c6588d;
  font-size: 0.8rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(198, 88, 141, 0.1);
  z-index: 1;
}

.lesson-container .exercise-card::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(198, 88, 141, 0.08));
  z-index: 0;
}

.lesson-container .exercise-card:hover {
  transform: translateY(-2px) translateX(2px);
  box-shadow: 0 6px 20px rgba(198, 88, 141, 0.15);
  border-color: #c6588d;
  background: linear-gradient(
    135deg,
    rgba(198, 88, 141, 0.12),
    rgba(232, 181, 209, 0.08)
  );
}

.lesson-container .exercise-level {
  font-weight: 700;
  color: #c6588d;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
  background: rgba(198, 88, 141, 0.15);
  padding: 4px 8px;
  border-radius: 6px;
  display: inline-block;
  position: relative;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(198, 88, 141, 0.2);
}

.lesson-container .exercise-content {
  position: relative;
  z-index: 2;
}

.lesson-container .exercise-content p {
  margin-bottom: 6px;
  line-height: 1.5;
}

.lesson-container .exercise-options {
  font-size: 0.75rem;
  margin: 6px 0;
  color: #555;
  padding-left: 10px;
}

.lesson-container .exercise-answer {
  font-weight: 600;
  color: #c6588d;
  font-size: 0.75rem;
  padding: 4px 8px;
  background: rgba(198, 88, 141, 0.1);
  border-radius: 4px;
  margin-top: 4px;
}

.lesson-container .content-cell ul {
  list-style: none;
  padding-left: 0;
  margin: 6px 0;
}

.lesson-container .content-cell li {
  position: relative;
  padding: 4px 0 4px 20px;
  margin-bottom: 3px;
  font-size: 0.8rem;
  color: #374151;
  line-height: 1.4;
}

.lesson-container .content-cell.inicio li::before {
  content: "●";
  position: absolute;
  left: 8px;
  top: 4px;
  font-size: 0.8rem;
  color: #20b2aa;
  text-shadow: 0 0 8px rgba(32, 178, 170, 0.4);
}

.lesson-container .content-cell.desarrollo li::before {
  content: "●";
  position: absolute;
  left: 8px;
  top: 4px;
  font-size: 0.8rem;
  color: #c6588d;
  text-shadow: 0 0 8px rgba(198, 88, 141, 0.4);
}

.lesson-container .content-cell.cierre li::before {
  content: "●";
  position: absolute;
  left: 8px;
  top: 4px;
  font-size: 0.8rem;
  color: #f8ac04;
  text-shadow: 0 0 8px rgba(248, 172, 4, 0.4);
}

@media (max-width: 768px) {
  .lesson-container {
    padding: 5px;
  }

  .lesson-container .container {
    border-radius: 8px;
  }

  .lesson-container .header {
    padding: 15px 20px;
  }

  .lesson-container .header h1 {
    font-size: 1.2rem;
  }

  .lesson-container .content-cell {
    padding: 10px 15px;
    font-size: 0.8rem;
  }

  .lesson-container .section-header {
    padding: 8px 12px;
    font-size: 0.8rem;
  }

  .lesson-container .floating-orb {
    width: 50px;
    height: 50px;
    top: 12px;
    right: 18px;
  }
}

@media (max-width: 480px) {
  .lesson-container .content-cell {
    font-size: 0.75rem;
  }

  .lesson-container .exercise-card {
    font-size: 0.75rem;
  }

  .lesson-container .subsection-title {
    font-size: 0.7rem;
  }
}
</style>

<!-- Estilos globales para contenido dinámico (v-html) -->
<style>
/* Variables CSS globales */
:root {
  --naranjo-fuerte: #f8ac04;
  --naranjo-suave: #f9d38f;
  --verde-fuerte: #20b2aa;
  --verde-suave: #84cec7;
  --morado-fuerte: #c6588d;
  --morado-suave: #e8b5d1;
}

/* Estilos para elementos strong dentro del contenido v-html */
.lesson-container .content-cell strong {
  color: #ffffff !important;
  padding: 3px 8px !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
  font-size: 0.8em !important;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2) !important;
  transition: all 0.2s ease !important;
  display: inline-block !important;
  margin: 1px 2px !important;
  position: relative !important;
  z-index: 1 !important;
}

.lesson-container .content-cell.inicio strong {
  background: linear-gradient(
    135deg,
    var(--verde-fuerte),
    var(--verde-suave)
  ) !important;
  box-shadow: 0 2px 8px rgba(32, 178, 170, 0.4) !important;
}

.lesson-container .content-cell.desarrollo strong {
  background: linear-gradient(
    135deg,
    var(--morado-fuerte),
    var(--morado-suave)
  ) !important;
  box-shadow: 0 2px 8px rgba(198, 88, 141, 0.4) !important;
}

.lesson-container .content-cell.cierre strong {
  background: linear-gradient(
    135deg,
    var(--naranjo-fuerte),
    var(--naranjo-suave)
  ) !important;
  box-shadow: 0 2px 8px rgba(248, 172, 4, 0.4) !important;
}

.lesson-container .content-cell strong:hover {
  transform: translateY(-1px) scale(1.05) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
  z-index: 2 !important;
}

/* Estilos para listas dentro del contenido v-html */
.lesson-container .content-cell ul {
  list-style: none !important;
  padding-left: 0 !important;
  margin: 6px 0 !important;
  position: relative !important;
}

.lesson-container .content-cell li {
  position: relative !important;
  padding: 4px 0 4px 20px !important;
  margin-bottom: 3px !important;
  font-size: 0.8rem !important;
  color: #374151 !important;
  line-height: 1.4 !important;
  transition: color 0.2s ease !important;
}

.lesson-container .content-cell li:hover {
  color: #1f2937 !important;
}

.lesson-container .content-cell.inicio li::before {
  content: "●" !important;
  position: absolute !important;
  left: 8px !important;
  top: 4px !important;
  font-size: 0.8rem !important;
  color: var(--verde-fuerte) !important;
  text-shadow: 0 0 8px rgba(32, 178, 170, 0.4) !important;
  transition: all 0.2s ease !important;
}

.lesson-container .content-cell.desarrollo li::before {
  content: "●" !important;
  position: absolute !important;
  left: 8px !important;
  top: 4px !important;
  font-size: 0.8rem !important;
  color: var(--morado-fuerte) !important;
  text-shadow: 0 0 8px rgba(198, 88, 141, 0.4) !important;
  transition: all 0.2s ease !important;
}

.lesson-container .content-cell.cierre li::before {
  content: "●" !important;
  position: absolute !important;
  left: 8px !important;
  top: 4px !important;
  font-size: 0.8rem !important;
  color: var(--naranjo-fuerte) !important;
  text-shadow: 0 0 8px rgba(248, 172, 4, 0.4) !important;
  transition: all 0.2s ease !important;
}

.lesson-container .content-cell li:hover::before {
  transform: scale(1.2) !important;
  text-shadow: 0 0 12px rgba(255, 255, 255, 0.6) !important;
}

/* Estilos para párrafos dentro del contenido v-html */
.lesson-container .content-cell p {
  margin-bottom: 6px !important;
  color: #374151 !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  transition: color 0.2s ease !important;
}

.lesson-container .content-cell p:last-child {
  margin-bottom: 0 !important;
}

/* Optimización para evitar conflictos de z-index */
.lesson-container .content-cell:hover .subsection-title {
  z-index: 1 !important;
}

.lesson-container .content-cell:hover .exercise-card {
  z-index: 1 !important;
}

/* Asegurar que los elementos de la tabla no interfieran con el header */
.lesson-container .planning-table {
  position: relative !important;
  z-index: 1 !important;
}
</style>
